var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-top-5 row width-100 center middle"},[_c('token-error',{attrs:{"title":_vm.$t("token.usedTokenTitle"),"message":_vm.$t("token.usedTokenMessage")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }